import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dropdown-list-item',
    templateUrl: './dropdown-list-item.component.html',
    styleUrls: ['./dropdown-list.component.scss'],
    standalone: false
})

export class DropdownListItemComponent<T> {
  @Input() public icon: string;
  @Input() public name: string;
}
